var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4071",
    "data-name": "Group 4071",
    transform: "translate(584 -1595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4056",
    "data-name": "Group 4056"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12527",
    "data-name": "Rectangle 12527",
    width: 30,
    height: 30,
    transform: "translate(-584 1595)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(-1287.469 1160)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    width: 15.911,
    height: 15.911,
    transform: "translate(712 442)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M15.811,14.419,12.53,11.137a6.809,6.809,0,0,0,1.392-4.177A6.918,6.918,0,0,0,6.961,0,6.918,6.918,0,0,0,0,6.961a6.918,6.918,0,0,0,6.961,6.961,6.809,6.809,0,0,0,4.177-1.392l3.282,3.282ZM1.989,6.961A4.924,4.924,0,0,1,6.961,1.989a4.924,4.924,0,0,1,4.972,4.972,4.924,4.924,0,0,1-4.972,4.972A4.924,4.924,0,0,1,1.989,6.961Z",
    transform: "translate(712 442)",
    fill: "#7a7a7a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.d057a6fe1bd91d80978135a62c778518.svg";
export { ForwardRef as ReactComponent };